<template>
  <LoadingPlaceholder v-if="loading"
                      class="loading-image"
                      :width="props.loaderWidth"
                      :height="props.loaderHeight"
                      :loading="loading"
  />
  <template v-else>
    <img :src="props.src"
         :srcset="props.srcset"
         v-bind="$attrs"
         ref="image"
    >
  </template>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import LoadingPlaceholder from '@/components/partials/Loading/LoadingPlaceholder.vue'
import { templateRef } from "@vueuse/core"

const image = templateRef<HTMLImageElement>('image')

const props = withDefaults(defineProps<{
  src?: string
  srcset?: string | undefined
  loaderHeight?: string
  loaderWidth?: string
}>(), {
  src: null,
  srcset: undefined,
  loaderHeight: '70%',
  loaderWidth: '100%',
})

const loading = ref<boolean>(true)

onMounted(() => {
  if (!props.src) {
    return
  }

  const image = new Image()
  image.src = props.src

  if (props.srcset) {
    image.srcset = props.srcset
  }

  image.style.display = 'none'

  image.addEventListener('load', () => {
    loading.value = false
  })

  image.addEventListener('error', () => {
    loading.value = false
  })

  document.body.appendChild(image)
})

</script>